import { fromJS } from 'immutable';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';

export const SUBSCRIPTION_REDUCER_KEY = 'subscriptionReducer';

export const SUBSCRIBE = 'SUBSCRIBE';

let defaultState = fromJS({
  hasSubscribed: false,
});

export default function(state = defaultState, action = {}) {
  switch (action.type) {
    case SUBSCRIBE: {
      return state.merge({
        hasSubscribed: true,
      });
    }
    default:
      return state;
  }
}

export const selectHasSubscribed = (state) => {
  return getIn(state[SUBSCRIPTION_REDUCER_KEY], 'hasSubscribed');
};
